module.exports = __webpack_public_path__ + "img/screenshot-1.0f147457.png";